const Policy = () => {
  const sideBar = () => {
    const highlightSidebar = document.querySelector(`.policy__select--container [href="${window.location.pathname}"]`);

    if (highlightSidebar) {
      highlightSidebar.classList.add('highlight');
    }
  };

  const whatsApp = () => {
    const onClickWhatsAppwidget = (e: Event) => {
      e.preventDefault();
      (document.querySelector('.aguadecoco-adventures-custom-link') as HTMLElement)?.click();
    };
    const whatsAppwidgets = document.querySelectorAll('[whatsApp-widget]');
    if (whatsAppwidgets.length <= 0) return;

    whatsAppwidgets.forEach((ele) => {
      ele.addEventListener('click', onClickWhatsAppwidget);
    });
  };

  sideBar();
  whatsApp();
};

Policy();
